export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const GET_PROFILE = 'GET_PROFILE'
export const PROFILE_UPDATE = 'PROFILE_UPDATE'
